import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatEUR } from "@/lib/format";

export const QtyStepper = ({ value, onChange, testid, size = "md" }) => {
  const box = size === "lg" ? "h-14 w-14" : "h-11 w-11";
  return (
    <div className="inline-flex items-center rounded-full border border-navy/20 bg-cream" data-testid={testid}>
      <button type="button" aria-label="Diminuisci quantità" onClick={() => onChange(value - 1)} data-testid={`${testid}-minus`} className={`grid ${box} place-items-center rounded-full text-navy transition-colors hover:bg-navy/5`}>
        <Minus className="h-4 w-4" />
      </button>
      <span className="min-w-8 text-center text-lg font-medium text-navy" data-testid={`${testid}-value`}>
        {value}
      </span>
      <button type="button" aria-label="Aumenta quantità" onClick={() => onChange(value + 1)} data-testid={`${testid}-plus`} className={`grid ${box} place-items-center rounded-full text-navy transition-colors hover:bg-navy/5`}>
        <Plus className="h-4 w-4" />
      </button>
    </div>
  );
};

export const CartLine = ({ item }) => {
  const { update, remove } = useCart();
  return (
    <li className="flex gap-4 py-5" data-testid={`cart-item-${item.slug}`}>
      <div className="h-28 w-[5.6rem] shrink-0 overflow-hidden rounded-xl bg-parchment">
        <img src={item.image} alt={item.name} className="h-full w-full object-cover" />
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="font-display text-xl leading-tight text-navy">{item.name}</p>
            <p className="mt-1 text-sm text-slate2">{item.size}</p>
          </div>
          <button type="button" onClick={() => remove(item.slug)} aria-label={`Rimuovi ${item.name}`} data-testid={`cart-remove-${item.slug}`} className="grid h-10 w-10 place-items-center rounded-full text-slate2 transition-colors hover:bg-navy/5 hover:text-navy">
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
        <div className="mt-auto flex items-center justify-between pt-3">
          <QtyStepper value={item.quantity} onChange={(q) => update(item.slug, q)} testid={`cart-qty-${item.slug}`} />
          <p className="font-display text-xl text-navy">{formatEUR(item.price * item.quantity)}</p>
        </div>
      </div>
    </li>
  );
};
